var module = 'profile', name = 'profile/config/locales/en.json', content = {
  "home": {
    "greeting": "Welcome, {{ patientFirstName }}",
    "title": "My appointments",
    "title_with_name": "{{name}}'s appointments",
    "assigment_labels": {
      "year": "Year",
      "date": "Date",
      "time": "Time",
      "reason": "Appointment type",
      "request_date": "Request date",
      "cancellation_reason": "Cancellation reason",
      "cancellation_date": "Cancellation date",
      "professional": "Healthcare professional",
      "location": "Location",
      "visit_reason": "Visit reason",
      "time_range": "to",
      "manitoba_language_access": "Language access"
    },
    "upcoming": {
      "title": "Upcoming appointments",
      "help": "For each appointment, two email notifications will be sent to you:<br>48 hr prior to your appointment and 1 hr before.",
      "none": "All your appointments are detailed here with the date, time and name of the healthcare professional you will see.",
      "no_fmd_none": "All your appointments are detailed here with the date and time.",
      "reminder": "Reminders will be sent 48 hours prior to your appointment, then one hour before.",
      "warning": {
        "reason_title": "You cannot make other appointment as you have one or more upcoming appointments",
        "phone_title": "For more information, contact us"
      },
      "attachments": {
        "title": "Attached files",
        "show": "Show",
        "hide": "Hide"
      },
      "additional_info": {
        "title": "Additional information",
        "details": "Details",
        "show_less": "Show less"
      }
    },
    "appointment_requests": {
      "title": "Service requests",
      "cancelled_title": "Cancelled service requests",
      "cancel_appointment_request": "Cancel this request",
      "description_line1": "This section displays all the service requests that are currently being processed by the clinic. ",
      "description_line2": "You will receive an appointment notice once your service request has been successfully processed. ",
      "description_line3": "If, for any reason, your service request should be refused, the clinic staff will contact you."
    },
    "history": {
      "title": "Appointment history",
      "none": "The appointment history allows you to have an overview of your medical records and frequency of your visits."
    },
    "recall_list": {
      "title": "Recalls",
      "recall_name": "Recall name",
      "professionnal": "Professional(s)",
      "actions": "Actions",
      "appointment_ready": "Book an appointment",
      "appointment_not_ready": "You will receive a notification from the clinic when the availabilities will be open for you.",
      "appointment_ready_multiple_reasons": "You can now make an appointment. To do this, use the buttons at the top of this page."
    },
    "warnings": {
      "no_offering": "There are no available appointment offers.",
      "family_physician": "You cannot book other appointments with your {{familyDoctorLabel}} as you have one or more upcoming appointments.",
      "walkin": "You cannot book more than one walk-in appointment at a time.",
      "other_offering": "You cannot book more than one {{description}} appointment at a time.",
      "no_family_doctor": "You cannot book {{familyDoctorLabel}} appointments since you don't have a {{familyDoctorLabel}} at this clinic or because your {{familyDoctorLabel}} does not offer the appointment online service.",
      "self_registration": "To speed up the reception and identity validation process upon your first clinic visit, please complete your personal information in the section",
      "noshow": "You appear to have missed an appointment. You must therefore contact the clinic to book another appointment.",
      "prevent_booking": "Please contact us to book an appointment."
    },
    "patient_message": {
      "details": "Details",
      "show_less": "Show less"
    },
    "take_appointment": "Book an appointment",
    "cancel_appointment": "Cancel this appointment",
    "confirm_appointment": "Confirm my presence",
    "confirmed_appointment": "Presence confirmed",
    "join_this_appointment": "Join this appointment",
    "copy_the_link": "Copy the link of this appointment",
    "link_will_appear": "Your appointment link will appear here around 10 minutes prior to your appointment. If it does not appear before the appointment's start time, please contact the clinic for further assistance.",
    "virtual_meeting_failed": "There was a problem creating your appointment link, please contact the clinic for further assistance"
  },

  "update": {
    "menu_trigger": "Back to menu",
    "tabs": {
      "my_profile": "My profile",
      "manage_notifications": "My notifications",
      "change_password": "My password",
      "change_email": "My email",
      "informations": "My personal information",
      "reminders": "My appointment reminders"
    },
    "profile": {
      "title": "My profile",
      "information": "Your profile presents information related to your account and appointment booking.",
      "linkedPatients": {
        "title": "Link a person to my account",
        "information": "You can link people to your account; for instance, members of your family, and manage the appointment booking from a single account.",
        "subtitle": "People linked to your account",
        "table": {
          "name": "Name",
          "hin": "HIN",
          "phin": "PHIN",
          "generic_hin": "PHN/PHIN",
          "blank": "No link",
          "added": "Linked person"
        },
        "associate": "Associate a new patient",
        "associateButton": "Associate",
        "labels": {
          "hin": "HIN",
          "phin": "PHIN",
          "first_name": "First name",
          "last_name": "Last name",
          "sharingConsent": "Sharing consent"
        },
        "sharingConsentWarning": "By checking this box, you accept the <a ui-sref=\"patient_agreement({locale: 'en'})\" target=\"_blank\">user agreement</a> on the behalf of the person you are linking to your account.",
        "helpText": "Please complete the fields below to link a person to your account.",
        "unlink_patient_action": "Unlink from account",
        "unlink_patient_text": "Unlink this person from your account?",
        "unlink_patient_cancel": "Cancel",
        "unlink_patient_confirm": "Unlink",
        "error": {
          "pattern": "The health insurance number must on the format of AAAA 1111 1111",
          "required_hin": "You must enter a valid HIN.",
          "required": "Required",
          "already_linked": "This person is already linked to another account.",
          "no_match": "The HIN and person name do not match.",
          "not_found": "The person was not found.",
          "already_confirmed": "It is not possible to link this person as they are already managing their account.",
          "self": "You cannot link your own account."
        }
      },
      "last_updated": {
        "clinic": "Last updated on {{date}} by the clinic",
        "yourself": "Last updated on {{date}} by you",
        "other_patient": "Last updated on {{date}} by {{patientName}}"
      }
    },
    "notification": {
      "heading": "Manage my notifications",
      "legend": "I wish to receive an email notification concerning openings in my {{familyDoctorLabel}}'s schedule:",
      "label_md": "Notifications for",
      "label_new": "Each time there are new availabilities",
      "label_next": "Only for the next availabilities",
      "label_specific": "Specifically for availabilities in the week of",
      "label_none": "I do not wish to receive notifications",
      "update_success": "Your notification settings have been successfully changed."
    },
    "reminders": {
      "title": "My appointment reminders",
      "information": "Please select the best way to reach you for your appointment reminders.",
      "contact_method_kinds": {
        "email": "Email",
        "sms": "SMS",
        "phone": "Automated phone"
      },
      "labels": {
        "reminder_method_kind": "Contact method"
      },
      "current": {
        "email": "Current email address",
        "sms": "Current mobile number",
        "phone": "Current phone number"
      },
      "errors": {
        "no_mobile_number": "You must first add a mobile number in your profile.",
        "no_phone_number": "You must first add a phone number in your profile."
      },
      "add_phone": "Add a phone number",
      "add_mobile": "Add a mobile number",
      "no_phone": "No phone number",
      "no_mobile": "No cell number",
      "update_success": "Your reminder settings have been successfully changed.",
      "update_success_added_phone": "Your reminder settings and phone numbers have been successfully changed",
      "current_method_email_go_edit": "Your email address is editable from the tab"
    },
    "password": {
      "heading": "My password",
      "subtitle": "Your password must be a minimum of eight characters and contain at least one capital letter and one number.",
      "labels": {
        "password": "Current password",
        "newPassword": "New password",
        "confirmNewPassword": "Confirm new password"
      },
      "errors": {
        "requiredPassword": "Please enter your current password.",
        "requiredNewPassword": "Please enter your new password.",
        "requiredConfirmNewPassword": "You forgot to confirm your password.",
        "noMatch": "Your passwords do not match",
        "passwordRequirements": "Your password must contain at least one capital letter and one number",
        "minlength": "Your password must have more than 8 characters",
        "maxlength": "Your password must have less than 256 characters",
        "wrongPassword": "The password is incorrect",
        "samePassword": "You need to change your password",
        "unexpected": "An unexpected error occurred, please try again"
      },
      "confirmation": {
        "title": "Do you really want to change your password?",
        "confirm": "Confirm change",
        "dismiss": "Cancel",
        "otherClinics": "The modification will apply on all your other accounts on the network:"
      },
      "updateSuccess": "Your password has been changed successfully."
    },
    "email": {
      "heading": "My email address",
      "subtitle": "Your email address is used to sign in to your account. It also allows you to receive appointment reminders and notifications of new availabilities. If you change your email address, we will send you a confirmation request message.",
      "hospital_booking_subtitle": "Your email address is used to sign in to your account. If you change your email address, we will send you a confirmation request message.",
      "currentEmail": "Current email address",
      "pendingConfirmation": "You must complete or cancel the current requested email change to proceed to a new email address change.",
      "pendingEmail": "Email address pending confirmation: {{ pendingEmail }}",
      "reauth_warning": "A re-authentication will be ask before changing your email.",
      "labels": {
        "newEmail": "New email address",
        "confirmNewEmail": "Confirm new email address"
      },
      "errors": {
        "requiredNewEmail": "Please enter your new email address.",
        "requiredConfirmNewEmail": "Please confirm your email address.",
        "noMatch": "The email addresses do not match.",
        "email": "This is not a valid email address",
        "sameEmail": "This email address is the same as your current one.",
        "unexpected": "An unexpected error occurred, please try again.",
        "alreadyTaken": "This email address is already used."
      },
      "confirmation": {
        "explanations": "A confirmation request message will be sent. The change will only be effective after this step.",
        "title": "Do you really want to change your email address?",
        "otherClinics": "The modification will apply on all your other accounts on the network:"
      },
      "banner": {
        "title": "You need to confirm your email address change. A confirmation email has been sent to {{ newEmail }}. The change will be effective only after this step is completed.",
        "resend": "Resend confirmation",
        "cancel": "Cancel the requested change",
        "success": "Your email address has been changed successfully!",
        "error": "An error has occured during the confirmation of your new email address. Please sign in again and click the Resend confirmation button.",
        "errorAlreadyConfirmed": "Your new email address has already been confirmed. You can now sign in."
      },
      "updateSuccess": "Your email address has been changed successfully."
    },
    "informations": {
      "cannot_update": "It is not possible to update your personal information from this website. To do so, you must call the clinic.",
      "labels": {
        "gender": "Gender",
        "last_name": "Last name",
        "first_name": "First name",
        "birthdate": "Birthdate",
        "age": "Age",
        "hin": "HIN",
        "phin": "PHIN",
        "generic_hin": "PHN/PHIN",
        "hin_expiration": "Expiration date",
        "father_name": "Name of the father",
        "mother_name": "Name of the mother",
        "conjoint_name": "Name of the spouse",
        "address": "Street address",
        "city": "City",
        "province": "State/Province",
        "country": "Country",
        "zip": "Postal code",
        "email": "Email address",
        "phone": "Phone number",
        "poste": "ext.",
        "allergies": "Allergies (Write <i>None</i> if you don't have any)",
        "medical_history": "Medical history (Write <i>None</i> if you don't have any)"
      },
      "list_items": {
        "years_old": "years old"
      },
      "titles": {
        "informations": "Personal information",
        "address": "Address",
        "contacts": "Email address and phone number",
        "medical_infos": "Allergies and medical history"
      },
      "actions": {
        "edit": "Edit",
        "add_phone": "Add a phone number"
      },
      "messages": {
        "masked_informations": "Vos informations personnelles sont masquées pour des raisons de sécurité. Celles-ci apparaîtront une fois que votre identité aura été validée lors de votre première visite à la clinique.",
        "showed_informations": "The information below will help the clinic staff confirm your identity.",
        "intro": "You can update your email address from the <strong>My email</strong> tab.",
        "order": "Your reminders number is editable from the tab",
        "reminders_number": "Reminders number"
      }
    },
    "btn_cancel": "Cancel",
    "btn_submit": "Save"
  }
}
;
angular.module(module).run(['$translationCache', function($translationCache) {
  $translationCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./profile/config/locales/en.json
// module id = 868
// module chunks = 0